import type { ReactNode } from 'react'
import { useLocation } from 'react-router'
import type { InterpolationFunction } from 'styled-components'
import styled from 'styled-components'

import user from 'legacy/utils/user'

import RateCommandCenterHeader from 'rate-command-center/ui/RateCommandCenterHeader'

import LoggedInNavigation from './LoggedInNavigation'
import LoggedOutNavigation from './LoggedOutNavigation'

interface PageWithSideNavProps {
  readonly children: ReactNode
  readonly color?: string
  readonly padding?: string | InterpolationFunction<any>
}

const Wrapper = styled.div`
  m-page-content > m-header {
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
  }
`

const MAGIC_LINK_MIGRATED_PATHS = ['/all-in-one']

function ShipperGuideLayout({ children, color, padding }: PageWithSideNavProps) {
  const { pathname } = useLocation()

  const renderSideAndTopNavigationForLoggedOutUser =
    user.isLoggedIn() === false && MAGIC_LINK_MIGRATED_PATHS.includes(pathname)

  if (renderSideAndTopNavigationForLoggedOutUser) {
    return (
      <LoggedOutNavigation color={color} padding={padding}>
        {children}
      </LoggedOutNavigation>
    )
  }

  /**
   * It was needed to create a specific scenario for tender page, because of the header
   * but since this is the next one in line to be migrated, it should be fixed soon.
   */
  if (user.isLoggedIn() === false && pathname === '/all-in-one/tender') {
    return (
      <>
        <RateCommandCenterHeader showAllInfo={false} />
        <Wrapper>{children}</Wrapper>
      </>
    )
  }

  if (user.isLoggedIn()) {
    return (
      <LoggedInNavigation color={color} padding={padding}>
        {children}
      </LoggedInNavigation>
    )
  }

  return null
}

export default ShipperGuideLayout
